import { render, staticRenderFns } from "./mappingDomainList.vue?vue&type=template&id=1f4373fe&scoped=true"
import script from "./mappingDomainList.vue?vue&type=script&lang=js"
export * from "./mappingDomainList.vue?vue&type=script&lang=js"
import style0 from "./mappingDomainList.vue?vue&type=style&index=0&id=1f4373fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4373fe",
  null
  
)

export default component.exports